import script from "./MyWorkOrderPending.vue?vue&type=script&setup=true&lang=js"
export * from "./MyWorkOrderPending.vue?vue&type=script&setup=true&lang=js"

import "./MyWorkOrderPending.vue?vue&type=style&index=0&id=6be8289c&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6be8289c"]])

export default __exports__